import $ from "jquery";
import './gppy-misc.js';
import {getParameterByName} from "./gppy-misc";

export function verifyTransaction () {
    var sessionId = getParameterByName("sessionId");
    Promise.resolve($.get('/api/verifyTransaction.html?sessionId='+sessionId)).then(
        transactionResult,
        transactionFailed
    )
}

function transactionResult(res) {
    if (res.state === "OK") transactionCorrect(res.details);
    if (res.state === "Failed") transactionFailed(res);
    if (res.state === "Waiting") setTimeout(verifyTransaction, 3000);
}

function transactionCorrect(details) {
    if (["P_ST", "P_PR", "P_C2", "P_C3", "P_C5", "P_ST_2", "P_PR_2", "P_C2_2", "P_C3_2", "P_C5_2", "P_ST_3", "P_PR_3", "P_C2_3", "P_C3_3", "P_C5_3"].indexOf(details.product) > -1) {
        $('#panel-waiting').addClass('hidden');
        $('#panel-success-PD').removeClass('hidden');
        $('#premiumUntilDate').text(details.premiumUntilDate);
    }
    if (details.product === "PS6" || details.product === "PS12") {
        $('#panel-waiting').addClass('hidden');
        $('#panel-success-PS').removeClass('hidden');
        $('#premiumUntilDatePS').text(details.premiumUntilDate);
    }
    if (details.product === "PAO_VD") {
        $('#panel-waiting').addClass('hidden');
        $('#panel-success-PAO').removeClass('hidden');
        $('#packageNamePAO').text(details.productDesc);
    }
    if (details.product === "PAO_EXT") {
        $('#panel-waiting').addClass('hidden');
        $('#panel-success-PAO').removeClass('hidden');
        $('#packageNamePAO').text(details.productDesc);
    }
    sendDataToGA(details);
}

function transactionFailed() {
    $('#panel-waiting').addClass('hidden');
    $('#panel-error').removeClass('hidden');
}


function sendDataToGA(details) {
    let lang = document.documentElement.getAttribute("lang").toLowerCase() === "pl" ? "pl" : "en";
    window.dataLayer = window.dataLayer || [];
    dataLayer.push({'event': 'purchase', 'ecommerce': {
        "transaction_id": details.transactionId,
        "affiliation": 'GardenPuzzle',
        "value": details.revenue,
        "currency": lang === "pl" ? 'PLN' : 'USD',
        "tax": 0,
        "shipping": 0,
        "items": [
            {
                "id": details.product,
                "name": details.product,
                "quantity": 1,
                "price": details.revenue
            }
        ]
    }});
}

$('document').ready(() => {
    if ($('.paymentthankyou').length) {
        verifyTransaction();
    }
})

